<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showPartidoTesoreria"
    scrollable
    no-close-on-backdrop
    size="lg"
    title="Detalle Valores de Tarjetas"
    cancel-variant="outline-secondary"
  >
    <b-table
      ref="refInvoiceListTable"
      :fields="tableColumns"
      :items="listTarjetas"
      primary-key="id_tarjeta"
      show-empty
      responsive
      small
      empty-text="No se encontraron datos"
      class="position-relative"
      style="max-height:60vh"
    >
      <!-- Column: Id -->
      <template #cell(num_camiseta)="data">
        <p class="font-weight-bold">
          {{ data.item.num_camiseta }}
        </p>
      </template>

      <!-- Column: Player -->
      <template #cell(jugador)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-avatar
              size="32"
              :src="data.item.foto_jug"
              :text="avatarText(data.item.nombre)"
            />
          </template>
          <span class="font-weight-bold d-block text-nowrap">
            {{ data.item.apellido }} {{ data.item.nombre }}
          </span>
        </b-media>
        <span class="font-weight-bold d-block text-nowrap">
          {{ data.item.apellidos }} {{ data.item.nombres }}
        </span>
      </template>
      <template #cell(equipo)>
        {{ institucion.nombre }}
      </template>
      <template #cell(tarjeta)="data">
        <div v-if="data.item.t_a == 1">
          <img
            :src="require('@/assets/images/recursos/amarilla.png')"
            alt=""
            width="20"
          />
        </div>
        <div v-else-if="data.item.t_r == 1">
          <img
            :src="require('@/assets/images/recursos/roja.png')"
            alt=""
            width="20"
          />
        </div>
        <div v-else-if="data.item.doble_a == 1">
          <img
            :src="require('@/assets/images/recursos/dosamar.png')"
            alt=""
            width="20"
          />
        </div>
      </template>
    </b-table>
  </b-modal>
</template>
<script>
// import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { avatarText } from '@core/utils/filter'
import {
  BModal,
  BTable,
  BMedia,
  BAvatar,
  // BRow,
  // BCol,
  // BFormInput,
  //   BTab,
  //   BTabs,
  //   BButton,
  //   BSpinner,
  // xx
} from 'bootstrap-vue'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { ref, watch } from '@vue/composition-api'
// import store from '@/store'
// import itemEtapa from './ItemEtapa.vue'
// import apiCall from '../../utils/apiCall'
// import {
//   URL,
//   USER,
//   ROLES,
//   // xx
// } from '../../utils/variables'
// import vSelect from 'vue-select'

export default {
  components: {
    BModal,
    BTable,
    BMedia,
    BAvatar,
  },
  directives: {
    Ripple,
  },
  props: {
    listTarjetas: Array,
    institucion: Object,
  },
  setup() {
    // const categoriaAdmin = ref(null)
    // const apodo = ref('')
    const tableColumns = [
      {
        key: 'num_camiseta',
        label: '#',
        stickyColumn: true,
        sortable: true,
      },
      { key: 'jugador', sortable: true },
      { key: 'equipo', sortable: true },
      { key: 'tarjeta', label: 'T', sortable: true },
      { key: 'motivo', label: 'Art.', sortable: true },
      { key: 'valor', label: 'valor', sortable: true },
    ]
    return {
      tableColumns,
      avatarText,
    }
  },
}
</script>
<style lang="scss"></style>
